import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Icon } from '../Icon/index.js';
import { Box } from '../Box/index.js';

const sizes = {
  sm: '24px',
  md: '32px',
  lg: '40px'
};
const StyledCloseButton = styled(Box).withConfig({
  shouldForwardProp: prop => {
    return !['dark'].includes(prop);
  }
}).withConfig({
  displayName: "CloseButton__StyledCloseButton",
  componentId: "sc-16cjmhy-0"
})(["background-color:transparent;border:none;cursor:pointer;outline:none;&:disabled{opacity:0.4;cursor:not-allowed;}&:hover:not(:disabled){background-color:", ";}&:active:not(:disabled){transition:none;background-color:", ";}"], _ref => {
  let {
    dark,
    color
  } = _ref;
  return dark ? themeGet('colors.carbon700') : color && themeGet(`colors.${color}100`);
}, _ref2 => {
  let {
    dark,
    color
  } = _ref2;
  return dark ? themeGet('colors.carbon600') : color && themeGet(`colors.${color}200`);
});
/**
 * CloseButton is essentially a button with a close icon.
 * It is used to handle the close functionality in feedback and
 * overlay components like Alerts, Toasts, Drawers and Modals.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/close-button#usage)
 * - [Props](https://blockparty.endpoint.com/components/close-button#props)
 * <br />
 *
 */
const CloseButton = /*#__PURE__*/forwardRef((_ref3, forwardedRef) => {
  let {
    children,
    size = 'sm',
    color = 'carbon',
    dataTestId = 'close-button',
    dark,
    isDisabled,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React__default.createElement(StyledCloseButton, _extends({
    ref: forwardedRef,
    _focusVisible: {
      boxShadow: 'focus'
    },
    "aria-label": "Close",
    as: "button",
    borderRadius: "radiusDefault",
    color: color,
    dark: dark,
    "data-test-id": dataTestId,
    disabled: isDisabled,
    display: "inline-flex",
    transition: "fast",
    transitionProperty: "background-color, box-shadow"
  }, rest), /*#__PURE__*/React__default.createElement(Icon, {
    "aria-hidden": true,
    "aria-label": undefined,
    color: dark ? 'white' : `${color}900`,
    name: "Close",
    size: sizes[size]
  }));
});

export { CloseButton };
